import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class HeaderStateService {
    private isHeaderAbsoluteDisplayedSubject$ = new BehaviorSubject<boolean>(false);
    public isHeaderAbsoluteDisplayed$ = this.isHeaderAbsoluteDisplayedSubject$.asObservable();

    public setDisplayedAbsoluteHeader(isAbsolute: boolean) {
        this.isHeaderAbsoluteDisplayedSubject$.next(isAbsolute);
    }
}
